import { createRoute } from "@tanstack/react-router";
import { Settings } from "lucide-react";
import { accountRoute } from "./account-page";

export const accountPreferencesRoute = createRoute({
  getParentRoute: () => accountRoute,
  path: "preferences",
  component: AccountPreferencesPage
});

export function AccountPreferencesPage() {
  return (
    <div>
      <div className="border-border border-b p-6">
        <h2
          className="text-xl font-semibold text-gray-900 dark:text-white"
          id="preferences-heading"
        >
          Preferences
        </h2>
        <p
          className="mt-1 text-sm text-gray-600 dark:text-gray-400"
          id="preferences-description"
        >
          Manage your preferences
        </p>
      </div>

      <div className="p-6">
        <section
          aria-labelledby="preferences-heading"
          aria-describedby="preferences-description"
        >
          <div
            className="flex min-h-[300px] flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 dark:border-gray-700"
            role="status"
            aria-live="polite"
          >
            <Settings
              className="mb-4 h-12 w-12 text-gray-400"
              aria-hidden="true"
            />
            <p className="text-lg font-medium text-gray-900 dark:text-white">
              Coming soon
            </p>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              Preferences will be available here soon.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
